"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxMeasure = void 0;
const compare_measure_1 = require("../compare-measure/compare-measure");
function maxMeasure(...items) {
    let max = items[0];
    for (let i = 1; i < items.length; i++) {
        const item = items[i];
        if (item != null && (max == null || (0, compare_measure_1.compareMeasure)(max, item) < 0)) {
            max = item;
        }
    }
    if (max == null) {
        throw new TypeError('Cannot determine maximum of empty array.');
    }
    return max;
}
exports.maxMeasure = maxMeasure;
